import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'
import {
  Container,
  Form,
  Modal,
  ModalBody,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Offcanvas,
  OffcanvasBody,
} from 'reactstrap'

//Import Icons
import FeatherIcon from 'feather-icons-react'

//Import images
import logodark from '../../assets/images/logo.png'
import logolight from '../../assets/images/logo.png'
import shop1 from '../../assets/images/shop/product/s-1.jpg'
import shop2 from '../../assets/images/shop/product/s-2.jpg'
import shop3 from '../../assets/images/shop/product/s-3.jpg'

import NavbarButtons from '../Shared/NavbarButtons'
import appStore from "../../assets/images/app/app-store.png"
import playStore from "../../assets/images/app/play-store.png"

import corporate from '../../assets/images/demo/corporate.png'
import crypto from '../../assets/images/demo/crypto.png'
import shop from '../../assets/images/demo/shop.png'
import portfolio from '../../assets/images/demo/portfolio.png'
import helpCenter from '../../assets/images/demo/help-center.png'
import hosting from '../../assets/images/demo/hosting.png'
import job from '../../assets/images/demo/job.png'
import forums from '../../assets/images/demo/forums.png'
import blog from '../../assets/images/demo/blog.png'
import nft from "../../assets/images/demo/nft.png"
import RightSidebar from './RightSidebar'
import withRouter from '../../common/data/withRouter'

// Base URL for all external General Propeller site links. Change here to retarget.
const GP_BASE_URL = 'https://generalpropeller.com'

// menu
// import { navLinks } from './menu';
// import { MenuItem } from './NavBarComponents';

class Topbar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      dropdownOpenShop: false,
      wishlistModal: false,
      dropdownIsOpen: false,
      open: false,
      position: 'end',
      dropdownOpen: false,
      landing: false,
      components: false,
      demo: false,
      doc: false,
      pages: false,
      company: false,
      account: false,
      email: false,
      blog: false,
      case: false,
      auth: false,
      login: false,
      signup: false,
      reset: false,
      utility: false,
      special: false,
      contact: false,
      multi: false,
      level2: false,
      isOffcanvasOpen: false
    }
    this.toggleLine = this.toggleLine.bind(this)
    this.toggleDropdownShop.bind(this)
    this.toggleWishlistModal.bind(this)
    this.toggleDropdownIsOpen.bind(this)
    this.toggleRightDrawer = this.toggleRightDrawer.bind(this)
    this.onDrawerClose = this.onDrawerClose.bind(this)
    this.toggleDropdown.bind(this)
    this.togglemodal.bind(this)
    this.removeActivation = this.removeActivation.bind(this)
  }

  /** 
  * Right sidebar drawer 
  **/

  toggleOffcanvas = () => {
    this.setState((prevState) => ({
      isOffcanvasOpen: !prevState.isOffcanvasOpen,
    }))
  }

  closeOffcanvas = () => {
    this.setState({ isOffcanvasOpen: false })
  }

  toggleRightDrawer = () => {
    this.setState({ position: 'right' })
    this.setState({ open: !this.state.open })
  }
  onDrawerClose = () => {
    this.setState({ open: false })
  }

  toggleWishlistModal = () => {
    this.setState((prevState) => ({
      wishlistModal: !prevState.wishlistModal,
    }))
  }

  toggleDropdownShop = () => {
    this.setState({
      dropdownOpenShop: !this.state.dropdownOpenShop,
    })
  }
  toggleDropdownIsOpen = () => {
    this.setState({
      dropdownIsOpen: !this.state.dropdownIsOpen,
    })
  }

  toggleDropdown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    })
  }
  togglemodal = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }))
  }

  toggleLine() {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }))
  }

  // Topbar Page Activation

  activateParentDropdown() {
    var menuItems = document.getElementsByClassName("sub-menu-item")
    
    if (menuItems) {
      var matchingMenuItem = null
      for (var idx = 0; idx < menuItems.length; idx++) {
        if (menuItems[idx].pathname === window.location.pathname) {
          matchingMenuItem = menuItems[idx]
        }
      }
      
      if (matchingMenuItem) {
        matchingMenuItem.classList.add('active')

        const immediateParent = matchingMenuItem.closest('li')
        if (immediateParent) {
          immediateParent.classList.add('active')
        }
        var parent = matchingMenuItem.closest(".parent-menu-item")

        if (parent) {
          parent.classList.add('active')

          var parentMenuitem = parent.querySelector('a')
          if (parentMenuitem) {
            parentMenuitem.classList.add('active')
          }
          var parentOfParent = parent.closest(".parent-parent-menu-item")
          if (parentOfParent) {
            parentOfParent.classList.add('active')
          }
        } else {
          parentOfParent = matchingMenuItem.closest(".parent-parent-menu-item")
          if (parentOfParent) {
            parentOfParent.classList.add('active')
          }
        }
      }
      return false
    }
    return false
  }

  componentDidUpdate() {
    window.scrollTo(0, 0)
    this.initializeNavigation()
  }

  initializeNavigation = () => {
    const pathName = window.location.pathname
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    this.removeActivation(items)
    for (var i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem)
    }
  }

  removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement
      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active")
        }
      }
    }
  }

  render() {

    const { isOffcanvasOpen } = this.state

    return (
      <React.Fragment>
        {this.props.tagline ? this.props.tagline : null}

        <header id="topnav" className="defaultscroll sticky">
          <Container>
            <div>
              {/* logo */}
              {this.props.hasDarkTopBar ? (
                <Link className="logo" to="/">
                  <img
                    src={logodark}
                    height="56"
                    className="logo-light-mode"
                    alt=""
                  />
                  <img
                    src={logolight}
                    height="56"
                    className="logo-dark-mode"
                    alt=""
                  />
                </Link>
              ) : (
                <Link className="logo" to="/">
                  <span className="logo-light-mode">
                    <img src={logodark} className="l-dark" height="56" alt="" />
                    <img
                      src={logolight}
                      className="l-light"
                      height="56"
                      alt=""
                    />
                  </span>
                  <img
                    src={logolight}
                    height="56"
                    className="logo-dark-mode"
                    alt=""
                  />
                </Link>
              )}
            </div>

            <div className="menu-extras">
              <div className="menu-item">
                <Link
                  to="#"
                  onClick={this.toggleLine}
                  className={
                    this.state.isOpen ? 'navbar-toggle open' : 'navbar-toggle'
                  }
                >
                  <div className="lines">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </Link>
              </div>
            </div>
            {(() => {
              if (this.props.router.location.pathname === '/index-developer') {
                return <NavbarButtons />
              }
              else if (
                this.props.router.location.pathname === '/index-it-solution-two'
              ) {
                return (
                  <ul className="buy-button list-inline mb-0">
                    <li className="list-inline-item mb-0">
                      <Dropdown
                        isOpen={this.state.dropdownOpen}
                        toggle={this.toggleDropdown}
                      >
                        <DropdownToggle
                          color="none"
                          type="button"
                          className="btn-link text-decoration-none dropdown-toggle p-0 pe-2"
                        >
                          <i className="uil uil-search text-muted"></i>
                        </DropdownToggle>
                        <DropdownMenu
                          end
                          className="dd-menu dropdown-menu-end bg-white shadow rounded border-0 mt-3 py-0"
                          style={{ width: "300px" }}
                        >
                          <div className='search-bar'>
                            <Form className="searchform">
                              <input
                                type="text"
                                id="text"
                                name="name"
                                className="form-control border rounded"
                                placeholder="Search..."
                              />
                            </Form>
                          </div>
                        </DropdownMenu>
                      </Dropdown>
                    </li>{" "}
                    <li className="list-inline-item mb-0">
                      <Link to="#" onClick={this.toggleOffcanvas}>
                        <div className="btn btn-icon btn-pills btn-primary settingbtn">
                          <FeatherIcon
                            icon="settings"
                            className="fea icon-sm"
                          />
                        </div>
                      </Link>
                    </li>{" "}
                    <li className="list-inline-item ps-1 mb-0">
                      <Link
                        to="//1.envato.market/landrickreactjs"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div id="buyButton" className="btn btn-icon btn-pills btn-primary shoppingbtn">
                          <FeatherIcon
                            icon="shopping-cart"
                            className="fea icon-sm"
                          />
                        </div>
                      </Link>
                    </li>
                  </ul>
                )
              }
              else if (
                this.props.router.location.pathname === '/shop-grids' ||
                this.props.router.location.pathname === '/shop-lists'
              ) {
                return (
                  <ul className="buy-button list-inline mb-0">
                    <li className="list-inline-item mb-0">
                      <Dropdown
                        isOpen={this.state.dropdownOpen}
                        toggle={this.toggleDropdown}
                      >
                        <DropdownToggle
                          direction="right"
                          color="none"
                          type="button"
                          className="btn btn-link text-decoration-none p-0 pe-2"
                        >
                          <i className="mdi mdi-magnify h4 text-muted"></i>
                        </DropdownToggle>
                        <DropdownMenu
                          end
                          className="dd-menu bg-white shadow rounded border-0 mt-3 py-0"
                          style={{ width: '300px' }}
                        >
                          <Form>
                            <input
                              type="text"
                              id="text"
                              name="name"
                              className="form-control border bg-white"
                              placeholder="Search..."
                            />
                          </Form>
                        </DropdownMenu>
                      </Dropdown>
                    </li>
                    <li className="list-inline-item mb-0 pe-1">
                      <Dropdown
                        isOpen={this.state.dropdownOpenShop}
                        toggle={this.toggleDropdownShop}
                      >
                        <DropdownToggle
                          type="button"
                          className="btn btn-icon btn-soft-primary "
                        >
                          <i className="uil uil-shopping-cart align-middle icons"></i>
                        </DropdownToggle>
                        <DropdownMenu
                          direction="left"
                          className="dd-menu bg-white shadow rounded border-0 mt-3 p-4"
                          style={{ width: '300px' }}
                        >
                          <div className="pb-4">
                            <Link to="#" className="media align-items-center">
                              <img
                                src={shop1}
                                className="shadow rounded"
                                style={{ maxWidth: '64px' }}
                                alt=""
                              />
                              <div className="flex-1 text-start ms-3">
                                <h6 className="text-dark mb-0">T-shirt (M)</h6>
                                <p className="text-muted mb-0">$320 X 2</p>
                              </div>
                              <h6 className="text-dark mb-0">$640</h6>
                            </Link>

                            <Link
                              to="#"
                              className="media align-items-center mt-4"
                            >
                              <img
                                src={shop2}
                                className="shadow rounded"
                                alt=""
                                style={{ maxWidth: '64px' }}
                              />
                              <div className="flex-1 text-start ms-3">
                                <h6 className="text-dark mb-0">Bag</h6>
                                <p className="text-muted mb-0">$50 X 5</p>
                              </div>
                              <h6 className="text-dark mb-0">$250</h6>
                            </Link>

                            <Link
                              to="#"
                              className="media align-items-center mt-4"
                            >
                              <img
                                src={shop3}
                                className="shadow rounded"
                                style={{ maxWidth: '64px' }}
                                alt=""
                              />
                              <div className="flex-1 text-start ms-3">
                                <h6 className="text-dark mb-0">Watch (Men)</h6>
                                <p className="text-muted mb-0">$800 X 1</p>
                              </div>
                              <h6 className="text-dark mb-0">$800</h6>
                            </Link>
                          </div>

                          <div className="media align-items-center justify-content-between pt-4 border-top">
                            <h6 className="text-dark mb-0">Total($):</h6>
                            <h6 className="text-dark mb-0">$1690</h6>
                          </div>

                          <div className="mt-3 text-center">
                            <Link to="#" className="btn btn-primary me-2">
                              View Cart
                            </Link>
                            <Link to="#" className="btn btn-primary">
                              Checkout
                            </Link>
                          </div>
                          <p className="text-muted text-start mt-1 mb-0">
                            *T&C Apply
                          </p>
                        </DropdownMenu>
                      </Dropdown>
                    </li>
                    <li className="list-inline-item mb-0 pe-1">
                      <Link
                        to="#"
                        className="btn btn-icon btn-soft-primary"
                        onClick={this.toggleWishlistModal}
                      >
                        <i className="uil uil-heart align-middle icons"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item mb-0">
                      <Dropdown
                        color="primary"
                        isOpen={this.state.dropdownIsOpen}
                        toggle={this.toggleDropdownIsOpen}
                      >
                        <DropdownToggle
                          type="button"
                          className="btn btn-icon btn-soft-primary"
                        >
                          <i className="uil uil-user align-middle icons"></i>
                        </DropdownToggle>
                        <DropdownMenu
                          direction="left"
                          className="dd-menu bg-white shadow rounded border-0 mt-3 py-3"
                          style={{ width: '200px' }}
                        >
                          <Link className="dropdown-item text-dark" to="#">
                            <i className="uil uil-user align-middle me-1"></i>{' '}
                            Account
                          </Link>
                          <Link className="dropdown-item text-dark" to="#">
                            <i className="uil uil-clipboard-notes align-middle me-1"></i>{' '}
                            Order History
                          </Link>
                          <Link className="dropdown-item text-dark" to="#">
                            <i className="uil uil-arrow-circle-down align-middle me-1"></i>{' '}
                            Download
                          </Link>
                          <div className="dropdown-divider my-3 border-top"></div>
                          <Link className="dropdown-item text-dark" to="#">
                            <i className="uil uil-sign-out-alt align-middle me-1"></i>{' '}
                            Logout
                          </Link>
                        </DropdownMenu>
                      </Dropdown>
                    </li>
                  </ul>
                )
              }
              else if (
                this.props.router.location.pathname === '/index-apps' ||
                this.props.router.location.pathname === '/index-classic-app' ||
                this.props.router.location.pathname === '/index-job'
              ) {
                return (
                  <ul className="buy-button list-inline mb-0">
                    <li className="list-inline-item mb-0">
                      <Link to="#" className="btn btn-icon btn-light">
                        <img src={appStore} className="avatar avatar-ex-small p-1" alt="" />
                      </Link>
                    </li>{" "}

                    <li className="list-inline-item mb-0">
                      <Link to="#" className="btn btn-icon btn-light">
                        <img src={playStore} className="avatar avatar-ex-small p-1" alt="" />
                      </Link>
                    </li>
                  </ul>
                )
              }
              else {
                return null
              }
            })()}

            <div id="navigation" style={{ display: this.state.isOpen ? 'block' : 'none' }}>

              {/* Menu Dropdown */}
              <ul className="navigation-menu nav-dark" id="top-menu">
                {/* Home */}
                <li><a href={`${GP_BASE_URL}/`} className="sub-menu-item">Home</a></li>

                {/* Products */}
                <li className="has-submenu parent-parent-menu-item">
                  <a href="#products" onClick={(e) => { e.preventDefault(); this.setState({ landing: !this.state.landing }) }}>Products</a><span className="menu-arrow"></span>
                  <ul className={classnames("submenu megamenu", { open: this.state.landing })}>
                    <li>
                      <ul>
                        <li className="megamenu-head"><a href={`${GP_BASE_URL}/propellers`}>Propellers</a></li>
                        <li><a href={`${GP_BASE_URL}/propellers/outboard-and-sterndrive`} className="sub-menu-item">Outboard-Sterndrive</a></li>
                        <li><a href={`${GP_BASE_URL}/propellers/ski-wakeboard-propellers`} className="sub-menu-item">Ski-Wakeboard Props</a></li>
                        <li><a href={`${GP_BASE_URL}/propellers/inboard-propellers`} className="sub-menu-item">Inboard Propellers</a></li>
                        <li><a href={`${GP_BASE_URL}/propellers/sailboat-propellers`} className="sub-menu-item">Sailboat Propellers</a></li>
                        <li><a href={`${GP_BASE_URL}/propellers/pod-drive-propellers`} className="sub-menu-item">Pod Drive Props</a></li>
                        <li><a href={`${GP_BASE_URL}/propellers/Used-Inboards`} className="sub-menu-item">Used Inboard Propellers</a></li>
                      </ul>
                    </li>

                    <li>
                      <ul>
                        <li className="megamenu-head"><a href={`${GP_BASE_URL}/Shaft-Seals`}>Seals for Inboard Shafts</a></li>
                        <li><a href={`${GP_BASE_URL}/Shaft-Seals/pyi-pss`} className="sub-menu-item">PYI - PSS Shaft Seals</a></li>
                        <li><a href={`${GP_BASE_URL}/Shaft-Seals/Volvo-Shaft-Seal`} className="sub-menu-item">Volvo Penta Shaft Seal</a></li>
                        <li><a href={`${GP_BASE_URL}/Shaft-Seals/tide-shaft-seals`} className="sub-menu-item">Tides Shaft Seals</a></li>
                        <li><a href={`${GP_BASE_URL}/Shaft-Seals/glide-shaft-seals`} className="sub-menu-item">Glide Dripless Shaft Seals</a></li>
                      </ul>
                    </li>

                    <li>
                      <ul>
                        <li className="megamenu-head"><a href={`${GP_BASE_URL}/inboard-shafts-and-couplings`}>Inboard Shafts/Couplings</a></li>
                        <li><a href={`${GP_BASE_URL}/inboard-shafts-and-couplings/inboard-shafts`} className="sub-menu-item">Inboard Shafts</a></li>
                        <li><a href={`${GP_BASE_URL}/inboard-shafts-and-couplings/buck-algonquin-couplings`} className="sub-menu-item">Buck Algonquin Couplings</a></li>
                        <li><a href={`${GP_BASE_URL}/inboard-shafts-and-couplings/RD-Split-Couplings`} className="sub-menu-item">R & D Split Couplings</a></li>
                        <li><a href={`${GP_BASE_URL}/inboard-shafts-and-couplings/RD-Flexible-Couplings`} className="sub-menu-item">R & D Flexible Couplings</a></li>
                        <li><a href={`${GP_BASE_URL}/inboard-shafts-and-couplings/isoflex-flex-couplings`} className="sub-menu-item">IsoFlex Gearguard Flex Couplings</a></li>
                        <li><a href={`${GP_BASE_URL}/inboard-shafts-and-couplings/linecutter`} className="sub-menu-item">Shaft Line Cutters</a></li>
                        <li><a href={`${GP_BASE_URL}/inboard-shafts-and-couplings/nuts-bolts`} className="sub-menu-item">Nuts & Bolts</a></li>
                        <li><a href={`${GP_BASE_URL}/inboard-shafts-and-couplings/Nylon-Bore-Reducers`} className="sub-menu-item">Nylon Bore Reducers</a></li>
                      </ul>
                    </li>

                    <li>
                      <ul>
                        <li className="megamenu-head"><a href={`${GP_BASE_URL}/marine-hardware`}>Marine Hardware</a></li>
                        <li><a href={`${GP_BASE_URL}/marine-hardware/buck-algonquin-hardware`} className="sub-menu-item">Buck Algonquin Hardware</a></li>
                        <li><a href={`${GP_BASE_URL}/marine-hardware/r-e-thomas`} className="sub-menu-item">R.E. Thomas Marine Hardware</a></li>
                        <li><a href={`${GP_BASE_URL}/marine-hardware/bearings`} className="sub-menu-item">Bearings</a></li>
                        <li><a href={`${GP_BASE_URL}/marine-hardware/Shaft-Seals`} className="sub-menu-item">Seals for Inboard Shafts</a></li>
                        <li><a href={`${GP_BASE_URL}/marine-hardware/zincs-anodes`} className="sub-menu-item">Zinc & Aluminum Anodes</a></li>
                        <li><a href={`${GP_BASE_URL}/marine-hardware/antifouling`} className="sub-menu-item">Antifouling Paint & Coatings</a></li>
                        <li><a href={`${GP_BASE_URL}/marine-hardware/isoflex-motor-mounts`} className="sub-menu-item">IsoFlex MAXImount Motor Mounts</a></li>
                        <li><a href={`${GP_BASE_URL}/marine-hardware/custom-fabrication`} className="sub-menu-item">Custom Stainless Fabrication</a></li>
                      </ul>
                    </li>

                    <li>
                      <ul>
                        <li className="megamenu-head"><a href={`${GP_BASE_URL}/propeller-pullers`}>Propeller Pullers</a></li>
                        <li><a href={`${GP_BASE_URL}/propeller-pullers/prop-knockers`} className="sub-menu-item">Prop Knockers</a></li>
                        <li><a href={`${GP_BASE_URL}/propeller-pullers/propsmith-pullers`} className="sub-menu-item">PropSmith Pullers</a></li>
                        <li><a href={`${GP_BASE_URL}/propeller-pullers/veem-pullers`} className="sub-menu-item">VEEM Prop Puller</a></li>
                        <li><a href={`${GP_BASE_URL}/propeller-pullers/minderman-pullers`} className="sub-menu-item">Minderman Pullers</a></li>
                        <li><a href={`${GP_BASE_URL}/propeller-pullers/Walter-Pullers`} className="sub-menu-item">Walter Pullers</a></li>
                        <li><a href={`${GP_BASE_URL}/propeller-pullers/acme-puller`} className="sub-menu-item">Acme Pullers</a></li>
                      </ul>
                    </li>
                  </ul>
                </li>

                {/* Services */}
                <li className="has-submenu parent-menu-item">
                  <a href="#services" onClick={(e) => { e.preventDefault(); this.setState({ pages: !this.state.pages }) }}>Services</a><span className="menu-arrow"></span>
                  <ul className={classnames("submenu", { open: this.state.pages })}>
                    <li><a href={`${GP_BASE_URL}/Propeller-Sizings-and-Drivetrain-consulting`} className="sub-menu-item">Propeller Sizings and Drivetrain consulting</a></li>
                    <li><a href={`${GP_BASE_URL}/propeller-reconditioning`} className="sub-menu-item">Propeller Repair & Reconditioning</a></li>
                    <li><a href={`${GP_BASE_URL}/prop-scan`} className="sub-menu-item">Prop Scan</a></li>
                    <li><a href={`${GP_BASE_URL}/dynamic-balancing`} className="sub-menu-item">Dynamic Balancing</a></li>
                    <li><a href={`${GP_BASE_URL}/Shaft-Machining-Reconditioning`} className="sub-menu-item">Shaft Machining & Reconditioning</a></li>
                    <li><a href={`${GP_BASE_URL}/fabrication-and-welding`} className="sub-menu-item">Welding & Fabrication</a></li>
                    <li><a href={`${GP_BASE_URL}/Demo-Prop-Program`} className="sub-menu-item">Demo Prop Program</a></li>
                    <li><a href={`${GP_BASE_URL}/PropSpeed`} className="sub-menu-item">PropSpeed</a></li>
                    <li><a href={`${GP_BASE_URL}/Custom-Inboard-Propellers`} className="sub-menu-item">Custom Inboard Propellers</a></li>
                  </ul>
                </li>

                {/* Information */}
                <li className="has-submenu parent-menu-item">
                  <a href="#information" onClick={(e) => { e.preventDefault(); this.setState({ demo: !this.state.demo }) }}>Information</a><span className="menu-arrow"></span>
                  <ul className={classnames("submenu", { open: this.state.demo })}>
                    <li><a href={`${GP_BASE_URL}/customer-service-team`} className="sub-menu-item">Customer Service Team</a></li>
                    <li><a href={`${GP_BASE_URL}/products`} className="sub-menu-item">Products</a></li>
                    <li><a href={`${GP_BASE_URL}/quick-quote-form`} className="sub-menu-item">Quick Quote Form</a></li>
                    <li><a href={`${GP_BASE_URL}/inboard-shaft-quote-form`} className="sub-menu-item">Inboard Shaft Quote Form</a></li>
                    <li><a href={`${GP_BASE_URL}/outboard-propeller-sizing-form`} className="sub-menu-item">Outboard Propeller Sizing Form</a></li>
                    <li><a href={`${GP_BASE_URL}/inboard-propeller-sizing-form`} className="sub-menu-item">Inboard Propeller Sizing Form</a></li>
                    <li><a href={`${GP_BASE_URL}/estimated-shipping-time`} className="sub-menu-item">Estimated Shipping Time</a></li>
                    <li><a href={`${GP_BASE_URL}/index.php?route=information/sitemap`} className="sub-menu-item">Site Map</a></li>
                  </ul>
                </li>

                {/* GP PropTalk Blog */}
                <li><a href={`${GP_BASE_URL}/blog`} className="sub-menu-item">GP PropTalk Blog</a></li>

                {/* Contact Us */}
                <li><a href={`${GP_BASE_URL}/index.php?route=information/contact`} className="sub-menu-item">Contact Us</a></li>
              </ul>
              {/* menu end */}
              <div className="buy-menu-btn d-none">
                <Link
                  to="//1.envato.market/landrickreactjs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Buy Now
                </Link>
              </div>
            </div>
          </Container>
        </header>

        <Modal
          isOpen={this.state.wishlistModal}
          tabIndex="-1"
          centered
          contentClassName="rounded shadow-lg border-0 overflow-hidden"
          toggle={this.toggleWishlistModal}
        >
          <ModalBody className="py-5">
            <div className="text-center">
              <div
                className="icon d-flex align-items-center justify-content-center bg-soft-danger rounded-circle mx-auto"
                style={{ height: '95px', width: '95px' }}
              >
                <h1 className="mb-0">
                  <i className="uil uil-heart-break align-middle"></i>
                </h1>
              </div>
              <div className="mt-4">
                <h4>Your wishlist is empty.</h4>
                <p className="text-muted">
                  Create your first wishlist request...
                </p>
                <div className="mt-4">
                  <Link to="#" className="btn btn-outline-primary">
                    + Create new wishlist
                  </Link>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        
        {/* Side Offcanvas */}
        <Offcanvas isOpen={isOffcanvasOpen} direction={this.state.position} toggle={this.toggleOffcanvas}>
          <OffcanvasBody>
            <RightSidebar onClose={this.closeOffcanvas} />
          </OffcanvasBody>
        </Offcanvas>

      </React.Fragment>
    )
  }
}

export default withRouter(Topbar)

